import { useMutation, useQuery } from "@apollo/client";
import { LocationGenerics } from "router/location";
import { wrapClick } from "utils";
import { ApproveServiceOrderForm } from "components/forms";
import { Modal } from "components/layouts";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import { useSearch } from "react-location";
import { APPROVE_SERVICE_ORDER, GET_SERVICE_ORDER } from "./apollo";
import * as yup from "yup";

export default function ApproveRATServiceOrderContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  refetch?: () => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const { data, loading } = useQuery(GET_SERVICE_ORDER, {
    variables: {
      id: searchParams.id,
    },
    notifyOnNetworkStatusChange: false,
    skip: !searchParams.id,
  });
  const [approveServiceOrder] = useMutation(APPROVE_SERVICE_ORDER);

  const form = useFormik({
    initialValues: {
      notes: "",
    },
    validationSchema: yup.object({
      notes: yup.string().required(),
    }),
    onSubmit: async (values) => {
      await approveServiceOrder({
        variables: { id: searchParams.id, ...values },
      }).then(({ data: result }) => {
        if (result?.approveServiceOrder?._id) {
          toast(
            JSON.stringify({
              type: "success",
              title: "RAT Service Order Approved Successfully",
            }),
          );
          refetch?.();
          form.resetForm();
          setOpen(false);
        } else {
          toast(
            JSON.stringify({
              type: "error",
              title: "Could not approve RAT Service Order",
            }),
          );
        }
      });
    },
    onReset: () => {
      setOpen(false);
    },
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      title="Approve Readiness Assessment Test"
      description="Provide notes for approving this readiness assessment test order"
      renderActions={() => (
        <button
          type="button"
          disabled={form.isSubmitting}
          className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm"
          onClick={wrapClick(form.handleSubmit)}
        >
          {form.isSubmitting ? "Approving..." : "Approve Order"}
        </button>
      )}
    >
      {data?.serviceOrder?._id && <ApproveServiceOrderForm form={form} />}
    </Modal>
  );
}
